export enum PaymentStatus {
  PAID = 'PAID',
  IN_PROGRESS = 'IN PROGRESS'
}
